// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles_hidden__2BnZw","loading":"styles_loading__iSjDb","loading_dot":"styles_loading_dot__KgxIi","loadingFade":"styles_loadingFade__1r_eM"};